import { themeColors } from "@/utils/themeColors";

export const AuthTitle = ({ children, ...props }: React.HTMLAttributes<HTMLHeadElement>) => {
    return (
        <h2 className="heading3" {...props}>
            {children}
        </h2>
    );
};

export const AuthDescription = ({ style, children }: React.HTMLAttributes<HTMLParagraphElement>) => {
    return (
        <p className="body2" style={{ color: themeColors.neutral3, ...style }}>
            {children}
        </p>
    );
};
